/**
 * BREAKPOINT HANDLER
 */

VP = window.VP || {};

(function( $ ) {
	/**
	 * PRIVATE VARIABLES
	 */
	var SELECTOR = {
		body: 'body',
	};
	// Just a list of callbacks for onChange event
	var breakpointListeners = [];

	/**
	 * PRIVATE FUNCTIONS
	 */

	function getCurrentBreakpointName () {
		if (VP.storyTracker && $("html").hasClass("viewasmobile")) {
			return "small";
		}
		return window.getComputedStyle($(SELECTOR.body)[0], ':after').getPropertyValue('content').replace(/\"/g, '');
	}

	function fireBreakpointChangeHandlers ( currentBreakpoint ) {
		breakpointListeners.forEach(function ( callback ) {
			callback(currentBreakpoint);
		});
	}

	/**
	 * Breakpoint handler attached to App
	 */
	VP.breakpoint = {

		currentBreakpoint: getCurrentBreakpointName(),

		init: function () {

			var _this = this;

			if ( this.initialized ) { return; }

			VP.documentEvents.onResize( function () {
				var currentBreakpoint = getCurrentBreakpointName();
				if ( _this.currentBreakpoint !== currentBreakpoint ) {
					_this.currentBreakpoint = currentBreakpoint;
					fireBreakpointChangeHandlers(currentBreakpoint);
				}
			}, true );

		},

		manual: function () {

			var _this = this;			
			var currentBreakpoint = getCurrentBreakpointName();
			if ( _this.currentBreakpoint !== currentBreakpoint ) {
				_this.currentBreakpoint = currentBreakpoint;
				fireBreakpointChangeHandlers(currentBreakpoint);
			}
			
		},
		manualfire: function () {
			var _this = this;			
			var currentBreakpoint = getCurrentBreakpointName();
			_this.currentBreakpoint = currentBreakpoint;
			fireBreakpointChangeHandlers(currentBreakpoint);			
		},
		/**
		 * Adds callback to run whenever breakpoint changes
		 * @param { {Function}} callback - The callback function
		 * @param {Boolean} fireImmediate - If callback will fire upon registration
		 */
		onChange: function ( callback, fireImmediate ) {

			if ( typeof callback !== 'function' ) { throw 'A breakpointChange callback must be function!'; }

			breakpointListeners.push( callback );

			if ( fireImmediate ) { callback( getCurrentBreakpointName() ); }
		}
	};
})(jQuery);
